import AmexHowItWorksItem from './AmexHowItWorksItem';

export default AmexHowItWorksItem;
